import { render, staticRenderFns } from "./subjectRecordsPage.vue?vue&type=template&id=81cc5e26&"
import script from "./subjectRecordsPage.vue?vue&type=script&lang=ts&"
export * from "./subjectRecordsPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports